import klass from './styles/ProductBadge.module.scss';
import { font, staticFont } from '../../../../shared/typography';
import { ProductBadgeSize } from '@services/MarppleShop/features/ProductBadge/type';

export enum ProductBadgeColorVariants {
  BLUE_FILLED = 'BLUE_FILLED',
  SKYBLUE_FILLED = 'SKYBLUE_FILLED',
  ORANGE_FILLED = 'ORANGE_FILLED',
  PURPLE_FILLED = 'PURPLE_FILLED',
  BLACK_FILLED = 'BLACK_FILLED',
  PINK_FILLED = 'PINK_FILLED',
  GRAY_FILLED = 'GRAY_FILLED',

  BLUE_TEXT = 'BLUE_TEXT',
  PURPLE_TEXT = 'PURPLE_TEXT',
}

export enum ProductBadgeShape {
  RECTANGLE = 'RECTANGLE',
  SQUARE = 'SQUARE',
}

export class ProductBadgeStyleHelper {
  static getBaseKlass(): string {
    return klass.product_badge;
  }

  static getLabelKlass(): string {
    return klass.label;
  }

  static getBaseTypo(size: ProductBadgeSize): string | undefined {
    const TYPO_MAP: Map<ProductBadgeSize, string> = new Map([
      [ProductBadgeSize.small, font('10_medium')],
      [ProductBadgeSize.medium, font('14_medium')],
    ]);

    return TYPO_MAP.get(size);
  }

  static getRankingTypo(size: ProductBadgeSize): string | undefined {
    const TYPO_MAP: Map<ProductBadgeSize, string> = new Map([
      [ProductBadgeSize.large, staticFont('bebas_14_bold')],
      [ProductBadgeSize.xLarge, staticFont('bebas_16_bold')],
    ]);

    return TYPO_MAP.get(size);
  }

  static getColorKlass(variant: ProductBadgeColorVariants): string {
    const COLOR_MAP: Record<ProductBadgeColorVariants, string> = {
      [ProductBadgeColorVariants.BLUE_FILLED]: klass.blue_filled,
      [ProductBadgeColorVariants.BLUE_TEXT]: klass.blue_text,
      [ProductBadgeColorVariants.SKYBLUE_FILLED]: klass.skyblue_filled,
      [ProductBadgeColorVariants.ORANGE_FILLED]: klass.orange_filled,
      [ProductBadgeColorVariants.PINK_FILLED]: klass.pink_filled,
      [ProductBadgeColorVariants.PURPLE_FILLED]: klass.purple_filled,
      [ProductBadgeColorVariants.PURPLE_TEXT]: klass.purple_text,
      [ProductBadgeColorVariants.BLACK_FILLED]: klass.black_filled,
      [ProductBadgeColorVariants.GRAY_FILLED]: klass.gray_filled,
    };

    return COLOR_MAP[variant];
  }

  static getShapeKlass(shape: ProductBadgeShape): string | undefined {
    const SHAPE_MAP: Map<ProductBadgeShape, string> = new Map([
      [ProductBadgeShape.SQUARE, klass.square],
      [ProductBadgeShape.RECTANGLE, ''],
    ]);

    return SHAPE_MAP.get(shape);
  }

  static getSizeKlass(size: ProductBadgeSize): string {
    const SIZE_MAP: Record<ProductBadgeSize, string> = {
      [ProductBadgeSize.small]: klass.small,
      [ProductBadgeSize.medium]: klass.medium,
      [ProductBadgeSize.large]: klass.large,
      [ProductBadgeSize.xLarge]: klass.xLarge,
    };

    return SIZE_MAP[size];
  }

  static getIconKlass(size: ProductBadgeSize): string {
    const ICON_SIZE_MAP: Record<ProductBadgeSize, string> = {
      [ProductBadgeSize.small]: klass.icon_medium,
      [ProductBadgeSize.medium]: klass.icon_medium,
      [ProductBadgeSize.large]: klass.icon_large,
      [ProductBadgeSize.xLarge]: klass.icon_large,
    };

    return ICON_SIZE_MAP[size];
  }
}
